import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  card: {
    maxWidth: "1800px",
    margin: "30px 10px 30px 10px",
  },
});
